import axios from "axios";
import {
  FETCH_PRODUCT_DATA,
  FETCH_GROUP_DATA,
  FETCH_MESSAGE_DATA,
  GET_PRODUCT_DETAIL,
  GET_USER_DETAIL,
  SET_PRODUCT_DATA,
  EDIT_PRODUCT_DATA,
  SET_PRODUCTGROUP_DATA,
  EDIT_MESSAGE_DATA,
  FETCH_COLOR_DATA,
  FETCH_PRODUCT_NAME_DATA,
  FETCH_PRODUCT_BY_CATEGORY,
  SET_EDIT_PRODUCT_DATA,
  FETCH_NFA_DEVICE_DATA
} from "./types";
import { baseUrl, webBaseUrl, newBackendBaseUrl } from "../config";
import { gqlQuery, productGetCompat, upsertProductColor, addProductVariants, updateProductVariant } from "./gqlClient";
import history from "../history";
// import moment from 'moment'
import 'url-search-params-polyfill';
// var config = require('../../../server/rms/rms-service-products/config/config')(process.env.NODE_ENV);

export const getProductData = (data) => async (dispatch) => {
  // Replaces legacy /product/get with the GraphQL productColorSearch query;
  // productGetCompat reshapes the result to the same { success, data } envelope.
  try {
    const payload = await productGetCompat(data);
    dispatch({
      type: FETCH_PRODUCT_DATA,
      payload,
    });
  } catch (e) {
    console.error("Error fetching product data:", e);
  }
};

export const setNewProduct = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  // return await axios.post(baseUrl+"/product/add-new-product", data, {
  return await axios.post(newBackendBaseUrl + "/connect-product/v1/product/add-product", data, {

      headers: { "x-access-token": token },
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
      return e.response.data;
    });
};

export const addnewVariant = (data) => async (dispatch) => {
  // Replaces REST /connect-product/v1/product/add-variant with the GraphQL upsert mutation.
  return addProductVariants(data);
};

// export const assignUserTicket = (data) => async (dispatch) => {
//   return await axios
//     .post(baseUrl + "/user/list-a", data, { headers: {} })
//     .then((res) => {
//       if (res.data.success) {
//         dispatch({
//           type: FETCH_PRODUCT_DATA,
//           payload: res.data,
//         });
//       }
//     })
//     .catch((e) => {
//       if (e.response.status === 401) {
//         history.push("/");
//       }
//     });
// };

export const getProductDetail = (data) => async (dispatch) => {
  // Replaces legacy /product/get with the GraphQL productColorSearch query.
  try {
    const payload = await productGetCompat(data);
    dispatch({
      type: GET_PRODUCT_DETAIL,
      payload,
    });
  } catch (e) {
    console.error("Error fetching product detail:", e);
  }
};

export const createProduct = (data) => async (dispatch) => {
  // Replaces legacy /product/upsert (add) with the GraphQL upsertProductColor mutation
  // (no product_color_id → insert a new variant).
  try {
    const res = await upsertProductColor(data);
    alert(res.message);
    const link = document.getElementById("product_close_icon_id_add");
    if (link) link.click();
    if (res.success) {
      dispatch({
        type: SET_PRODUCT_DATA,
        payload: { success: true, message: res.message, data: res },
      });
    }
  } catch (e) {
    console.error("Error adding product variant:", e);
    alert("Something went wrong");
  }
};

export const editProductData = (data) => async (dispatch) => {
  // Replaces legacy /product/upsert (edit) with the GraphQL upsertProductColor mutation
  // (product_color_id present → update). The message matches what ProductComponent's
  // callEditApi checks for so the modal closes and the list refreshes.
  try {
    const res = await upsertProductColor(data);
    dispatch({
      type: EDIT_PRODUCT_DATA,
      payload: {
        success: res.success,
        message: res.success ? "Product Updated Successfully." : (res.message || "Update failed"),
        data: res,
      },
    });
  } catch (e) {
    console.error("Error updating product variant:", e);
    dispatch({
      type: EDIT_PRODUCT_DATA,
      payload: { success: false, message: "Update failed" },
    });
  }
};

export const getGroupData = (data) => async (dispatch) => {
  // Replaces legacy /product/getproductCategories with the GraphQL `groups` query.
  // Consumers read groupData.data as a list of { id, group_name }; filterText drives the
  // group-management search box (pagination there is disabled).
  try {
    const result = await gqlQuery(
      `query ($filterText: String) {
        groups(filterText: $filterText) {
          id
          group_name
        }
      }`,
      data && data.filterText ? { filterText: data.filterText } : {}
    );
    const payload = { success: true, data: result.groups };
    dispatch({
      type: FETCH_GROUP_DATA,
      payload,
    });
    return payload;
  } catch (e) {
    console.error("Error fetching group data:", e);
  }
};

export const fetchAllProductsByCategoryId = (data) => async (dispatch) => {
  // Replaces legacy GET /product/fetch-all-products with the GraphQL `products` query.
  // Consumers read productListByCat as a flat array of { id, product_name }.
  const groupId = data && (data.category_id != null ? data.category_id : data.product_group_id);
  try {
    const result = await gqlQuery(
      `query ($productGroupIds: [Int!]) {
        products(filter: { productGroupIds: $productGroupIds }) {
          id
          product_name
          product_group_id
        }
      }`,
      groupId != null && groupId !== "" ? { productGroupIds: [Number(groupId)] } : {}
    );
    dispatch({
      type: FETCH_PRODUCT_BY_CATEGORY,
      payload: result.products,
    });
  } catch (e) {
    console.error("Error fetching products by category:", e);
  }
};

export const getProductNameData = (data) => async (dispatch) => {
  // Replaces legacy /product/get with the GraphQL productColorSearch query.
  // productGetCompat returns the same { success, data: { products, count,
  // next_page, prev_page } } envelope, so the dispatched payload is unchanged.
  try {
    const payload = await productGetCompat(data);
    dispatch({
      type: FETCH_PRODUCT_NAME_DATA,
      payload,
    });
  } catch (e) {
    console.error("Error fetching product name data:", e);
  }
};

export const getProductColorData = (data) => async (dispatch) => {
  // Replaces legacy /product/color-list with the GraphQL `colors` query. Consumers read
  // clolorList.data.colors and filter client-side, so the offset/limit params aren't needed.
  try {
    const result = await gqlQuery(
      `query {
        colors {
          id
          name
          description
          status
        }
      }`
    );
    dispatch({
      type: FETCH_COLOR_DATA,
      payload: { success: true, data: { colors: result.colors } },
    });
  } catch (e) {
    console.error("Error fetching colors:", e);
  }
};

export const createProductGroup = (data) => async (dispatch) => {
  // Replaces legacy /product/upsert-category with the GraphQL upsertProductGroup mutation.
  // The old { category_id, name, status } body maps onto the ProductGroupInput.
  try {
    const result = await gqlQuery(
      `mutation ($input: ProductGroupInput!) {
        upsertProductGroup(input: $input) { success message id }
      }`,
      {
        input: {
          ...(data.category_id ? { id: Number(data.category_id) } : {}),
          name: data.name,
          ...(data.status ? { status: String(data.status) } : {}),
        },
      }
    );
    const res = result.upsertProductGroup;
    alert(res.message);
    var link = document.getElementById("product_close_id");
    if (link) link.click();
    if (res.success) {
      dispatch({
        type: SET_PRODUCTGROUP_DATA,
        payload: { success: true, message: res.message },
      });
    }
  } catch (e) {
    console.error("Error creating product group:", e);
  }
};

export const getMessageData = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-message/v1/get", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      dispatch({
        type: FETCH_MESSAGE_DATA,
        payload: res.data,
      });
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const getMessageDetail = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(baseUrl + "/user/get/2", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: GET_USER_DETAIL,
          payload: res.data,
        });
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const getGroupDetail = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(baseUrl + "/user/get/2", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: GET_USER_DETAIL,
          payload: res.data,
        });
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const editMessageData = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .post(newBackendBaseUrl + "/connect-message/v1/upsert", data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      alert(res.data.message);
      if (res.data.success) {
        dispatch({
          type: EDIT_MESSAGE_DATA,
          payload: res.data,
        });
      }
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
      if (e.response.status === 429) {
        alert(e.response.statusText || "Something went wrong");
      }
    });
};

export const removeMessageData = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  let id = data.message_id;
  return await axios
    .post(newBackendBaseUrl + "/connect-message/v1/remove/" + id, {}, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      alert(res.data.message);
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const removeGroupData = (data) => async (dispatch) => {
  // Replaces legacy /product/remove-category/:id with the GraphQL removeProductGroup mutation.
  try {
    const result = await gqlQuery(
      `mutation ($id: Int!) {
        removeProductGroup(id: $id) { success message }
      }`,
      { id: Number(data.group_id) }
    );
    alert(result.removeProductGroup.message);
  } catch (e) {
    console.error("Error removing product group:", e);
  }
};

export const removeProductinfo = (data) => async (dispatch) => {
  // Replaces legacy /product/remove/:productColorId with the GraphQL removeProductColor mutation.
  try {
    const result = await gqlQuery(
      `mutation ($id: Int!) {
        removeProductColor(id: $id) { success message }
      }`,
      { id: Number(data) }
    );
    alert(result.removeProductColor.message);
  } catch (e) {
    console.error("Error removing product:", e);
  }
};

export const addNewColor = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    // .post(baseUrl + "/product/create-new-color" ,data, {
    .post(newBackendBaseUrl + "/connect-product/v1/add-new-color", data, {

      headers: { "x-access-token": token },
    })
    .then((res) => {
      return res.data
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
      return e.response.data;

    });
};
export const csvUploadAction = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");

  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/csv-upload" ,data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      return res.data
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const setProductID = (data) => async (dispatch) => {
  dispatch({
    type: SET_EDIT_PRODUCT_DATA,
    payload: data,
  });
};

export const addChannels = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");

  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/channel/add" ,data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      return res.data
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });

};

export const updateChannels = (data) => async (dispatch) => {
  let token = localStorage.getItem("token");

  return await axios
    .post(newBackendBaseUrl + "/connect-complaint/v1/complaint/update-channels" ,data, {
      headers: { "x-access-token": token },
    })
    .then((res) => {
      return res.data
    })
    .catch((e) => {
      if (e.response.status === 401) {
        history.push("/");
      }
    });
};

export const updateVariant = (data) => async (dispatch) => {
  // Replaces REST /connect-product/v1/product/update-variant with the GraphQL upsert mutation.
  return updateProductVariant(data);
};

export const fetchNFADeviceList = () => async (dispatch) => {
  let token = localStorage.getItem("token");
  return await axios
    .get(
      webBaseUrl + "/user_detail/watch/devices/list" ,
      { headers: { "x-access-token": token } }
    )
    .then((res) => {
      if (res.data.success) {
        dispatch({
          type: FETCH_NFA_DEVICE_DATA,
          payload: res.data.data,
        });
      } else {
        alert(res.data.message);
      }
    })
    .catch((e) => {
      history.push("/");
    });
};
